import APIService from '../api.service';

export const List = (params) => {
    return APIService.get(`/v01/stock-movements`, {
        params: {
            per_page: params.perPage,
            page: params.page,
            keyword: params.keyword,
            movement_type: params.movement_type,
            status: params.status,
            start_date: params.startDate,
            end_date: params.endDate,
        },
    });
};

export const Show = (id) => {
    return APIService.get(`/v01/stock-movements/${id}`);
};

export const Create = (data) => {
    return APIService.post(`/v01/stock-movements`, data);
};

export const Confirm = (id) => {
    return APIService.post(`/v01/stock-movements/${id}/confirm`);
};

const StockMovementService = {
    List,
    Show,
    Create,
    Confirm,
};

export default StockMovementService;
